import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import RenderDatePicker from "./RenderDatePicker";
import "react-responsive-modal/styles.css";
import "react-toastify/dist/ReactToastify.css";
import GTLabel from "components/GTLabel";
import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
import SingleSelect from "components/Select/SingleSelect";
import { Button } from "@material-ui/core";
import SearchInput from "./SearchInput";
import downloadWhite from "images/downloadWhite.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotesData,
  getEntityList,
  getGstinByEntity,
  setDefaultEntity,
  setSelectedGstin,
  setSelectedPeriods,
  setProfileData,
  downloadNotesExcel,
  setSelectedModule,
  setSelectedCategory,
  setSearch,
  setSelectedNotes,
  setSelectedRowNotes,
  getUserModules,
} from "./action";
import { errorToastMessage } from "utils/errorToast";

// Dummy components for now

// const RenderDatePicker = () => (
//   <input
//     type="date"
//     style={{ padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
//   />
// );

const HeaderBar = (props) => {
  const dispatch = useDispatch();

  const {
    loaderStatus,
    tableData,
    entityMasterList,
    defaultEntity,
    profileData,
    selectedGstin: storeSelectedGstin,
    selectedPeriods,
    selectedRowNotes,
    selectedNotes,
    moduleIds,
    selectedModule,
    selectedCategory,
    search,
  } = useSelector((store) => store.notesReducer);
  const searchRef = useRef(search);
  const interval = useRef("");
  const debounceTimeout = useRef(null);

  // Local state for form fields
  const [profile, setProfile] = useState([]);
  const [categoryProfile, setCategoryProfile] = useState([]);

  // Module options - dummy data for now
  const getModuleList = () => [
    { value: "1", label: "GST Module" },
    { value: "7", label: "Income Tax Module" },
    { value: "tds", label: "TDS Module" },
  ];

  // Category options - dummy data for now
  const getCategoryList = () => [
    { value: "working_file", label: "Working File" },
    { value: "filed_return", label: "Filed Return" },
  ];

  // Initialize profile data structure
  useEffect(() => {
    let newProfile =
      profileData?.length > 0
        ? profileData.map((v) => ({ ...v, label: v.gstin, value: v.gstin }))
        : [];

    const AllProfile = [
      {
        label: "All GSTIN",
        value: "All GSTIN",
        checked: newProfile.length > 0,
        tagClassName: "special",
        children: newProfile,
      },
    ];
    setProfile(AllProfile);
  }, [profileData]);

  // Initialize category profile data structure
  useEffect(() => {
    const categoryOptions = getCategoryList();
    const categoryChildren = categoryOptions.map((option) => ({
      label: option.label,
      value: option.value,
      checked: selectedCategory?.includes(option.value) || false,
    }));

    setCategoryProfile(categoryChildren);
  }, [selectedCategory]);

  // Load entity list on component mount
  useEffect(() => {
    dispatch(getEntityList());
    dispatch(getUserModules())
  }, []);

  // Get formatted entity master list
  const getEntityMasterList = () => {
    return entityMasterList?.map((item) => {
      if (item?.value && defaultEntity)
        item.checked = item.value === defaultEntity;
      return item;
    });
  };

  // Handlers
  const handleModule = (value) => {
    dispatch(setSelectedModule(value));
    console.log("Selected module:", value);
  };

  const handleEntity = async (value) => {
    try {
      dispatch(setDefaultEntity(value || ""));

      if (value) {
        const gstinList = await dispatch(getGstinByEntity(value));
        const allGstinList = gstinList?.map((item) => item?.gstin);
        dispatch(setSelectedGstin(allGstinList || []));
      } else {
        await dispatch(setProfileData([]));
        dispatch(setSelectedGstin([]));
      }
    } catch (error) {
      console.log("Error in handleEntity:", error);
    }
  };

  const handleGstin = async (currentNode, selectedNodes) => {
    let gstArr = [];
    if (selectedNodes[0]?.label === "All GSTIN") {
      var newProfile =
        profileData.length > 0
          ? profileData.map((v) => ({
              ...v,
              label: v.gstin || v.GSTIN,
              value: v.gstin || v.GSTIN,
            }))
          : [];
      gstArr = newProfile?.map((item) => {
        return item.gstin;
      });
    } else {
      gstArr = selectedNodes.map((item) => {
        return item.gstin || item.GSTIN;
      });
    }
    dispatch(setSelectedGstin(gstArr));
  };

  const handleCategory = async (currentNode, selectedNodes) => {
    const categoryArr = selectedNodes.map((item) => item.value);
    dispatch(setSelectedCategory(categoryArr));
    console.log("Selected categories:", categoryArr);
  };

  const handlePeriodsChange = (periods) => {
    dispatch(setSelectedPeriods(periods));
    console.log("Selected periods:", periods);
  };

  // const handleSearchChange = (searchValue) => {
  //   dispatch(setSearch(searchValue));
  //   console.log("Search value:", searchValue);
  // };
  const handleInputChange = (event) => {
    const value = event?.target?.value || "";
    dispatch(setSearch(value));
    searchRef.current = value;

    // Clear polling interval if any
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null; // Set to null
      console.log("🧹 Interval cleared due to search change");
    }

    // Debounce logic
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      props.handleSubmit(false, props.pageNo, value);
      props.setPageNo(1);
      console.log("Debounce Call searchStr:", value);
    }, 800);
  };

  // Submit handler
  // const handleSubmit = async () => {
  //   console.log("Submit clicked with data:", {
  //     selectedModule,
  //     defaultEntity,
  //     storeSelectedGstin,
  //     selectedCategory,
  //     selectedPeriods,
  //     search
  //   });

  //   if (!selectedModule || !defaultEntity || !storeSelectedGstin.length || !selectedCategory) {
  //     alert("Please fill all required fields");
  //     return;
  //   }

  //   if (!selectedPeriods.length) {
  //     alert("Please select at least one period");
  //     return;
  //   }

  //   try {
  //     const result = await dispatch(getNotesData(
  //       storeSelectedGstin,
  //       selectedModule,
  //       defaultEntity,
  //       selectedCategory,
  //       selectedPeriods,
  //       search,
  //       true // isToast
  //     ));
  //     console.log("API Response:", result);
  //   } catch (error) {
  //     console.error("Error in handleSubmit:", error);
  //   }
  // };

  // Download handler
  const handleDownload = async () => {
    console.log("Download clicked with data:", {
      selectedRowNotes,
      selectedModule,
      defaultEntity,
      selectedCategory,
      selectedPeriods,
    });
    if (tableData?.length === 0) {
      errorToastMessage("No data available to download");
      return;
    }
    if (selectedNotes?.length === 0) {
      errorToastMessage("Please select at least one record to download");
      return;
    }

    try {
      await dispatch(downloadNotesExcel(selectedNotes));
      dispatch(setSelectedNotes([]));
      dispatch(setSelectedRowNotes([]));
      console.log("Download initiated successfully");
    } catch (error) {
      console.error("Error in handleDownload:", error);
    }
  };
    const getFilteredModules = (moduleData) => {
    const excludedModuleIds = [1, 2, 6, 7, 9, 16, 18];
    return moduleData?.filter(moduleItem => 
      !excludedModuleIds.includes(moduleItem.moduleId) && 
      moduleItem.module_name // Also filter out modules without names
    ).map(moduleItem => {
      let displayLabel = moduleItem.module_name;
      
      // Custom label mapping
      if (moduleItem.module_name === "GSTR-9") {
        displayLabel = "GSTR-9/9C";
      } else if (moduleItem.module_name === "IMS") {
        displayLabel = "IMS Reco";
      }
      
      return {
        value: moduleItem.moduleId,
        label: displayLabel
      };
    }) || [];
  };
  useEffect(() => {
    console.log("moduleIds in header::", moduleIds);
  }, []);

  // Clear selections on component unmount
  useEffect(() => {
    return () => {
      dispatch(setSelectedNotes([]));
      dispatch(setSelectedRowNotes([]));
      dispatch(setDefaultEntity(""));
      dispatch(setSelectedGstin([]));
      dispatch(setSelectedModule(""));
      dispatch(setSelectedCategory([]));
      dispatch(setSelectedPeriods([]));
      dispatch(setSearch(""));
      dispatch(setProfileData([]));
    };
  }, []);
  return (
    <>
      <div style={{ display: "flex", width: "100%" }}>
        <div
          className="dropdown-container-notes"
          style={{
            marginRight: "10px",
            width: "20%",
          }}
        >
          <GTLabel title={"Select Module *"} />

          <SingleSelect
            values={getFilteredModules(moduleIds)}
            optionHeading={"Select"}
            selectedValue={selectedModule}
            handleChange={(e) => handleModule(e.target.value)}
          />
        </div>
        <div
          className="dropdown-container-notes"
          style={{
            marginRight: "10px",
            width: "20%",
           
          }}
        >
          <GTLabel title={"Select Entity Name *"} />

          <SingleSelect
            values={getEntityMasterList()}
            optionHeading={"Select"}
            selectedValue={defaultEntity}
            handleChange={(e) => handleEntity(e.target.value)}
          />
        </div>
        <div
          className="dropdown-container-notes"
          style={{
            // marginLeft: "10px",
            marginRight: "10px",
            width: "21%",
            zIndex: 101,
          }}
        >
          <GTLabel title={"Select GSTIN *"} />
          <Container
            data={profile?.map((item) => {
              if (
                storeSelectedGstin &&
                Array.isArray(storeSelectedGstin) &&
                storeSelectedGstin.length > 0
              ) {
                if (
                  item.children &&
                  item.children.length !== storeSelectedGstin.length
                ) {
                  item.checked = false;

                  item.children = item.children.map((chItem) => {
                    chItem.checked = storeSelectedGstin.find(
                      (x) => x === chItem.gstin || x === chItem.GSTIN
                    )
                      ? true
                      : false;
                    return chItem;
                  });
                }
              }

              return item;
            })}
            onChange={handleGstin}
            isDisabled={profileData.length === 0}
          />
        </div>

        <div
          style={{
            marginLeft: "10px",
            marginRight: "10px",
            marginTop: "5px",
            zIndex:100
          }}
          id="notes-datepicker"
        >
          <RenderDatePicker onPeriodsChange={handlePeriodsChange} />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        <div style={{ display: "flex", alignItems: "end", width: "100%" }}>
          <div
            className="dropdown-container-notes"
            style={{
              marginRight: "10px",
              width: "40%",
              zIndex: 99,
            }}
          >
            <GTLabel title={"Select Category *"} />
            <Container
              data={categoryProfile?.map((item) => ({
                ...item,
                checked: selectedCategory?.includes(item.value) || false,
              }))}
              onChange={handleCategory}
              isDisabled={false}
            />
          </div>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={(e) => props.handleSubmit(e)}
            disabled={loaderStatus}
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              textTransform: "capitalize",
              height: "30px",
              marginLeft: "1em",
              paddingLeft: "2em",
              paddingRight: "2em",
            }}
          >
            Submit
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <SearchInput value={search} onChange={handleInputChange} />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={handleDownload}
            disabled={loaderStatus}
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              textTransform: "capitalize",
              height: "30px",
              // marginLeft:'1em'
            }}
          >
            <img src={downloadWhite} alt="Download" className="download-icon" />
            Download Notes
          </Button>
        </div>
      </div>
    </>
  );
};

export default HeaderBar;
